import { Button, Icons, useToggle } from '@commenda/kakashi';
import { ConfirmationModal } from '../../../../molecules/modals/ConfirmationModal';
import {
  TaskParty,
  TaskStatus,
} from '@prisma/client';
import { ServiceRequestTaskLabel } from '../../../common/labels';
import { ServiceRequestTaskIconConfig } from '../../../common/taskIconConfig';
import { ServiceRequestTaskCard } from '../../../layout/components/taskCard/ServiceRequestTaskCard';
import { ServiceRequestTaskCardConfig, TCommonTaskProp } from '../../../types';
import { updateTaskStatus } from '../../../utils';

export const SourceStampPaperTask = ({
  task,
  context,
  isTimelineView,
  displayNumber,
}: TCommonTaskProp) => {
  const { role, mutate } = context;

  const stampPaperModalVisibility = useToggle();

  const handleMarkAsFiled = async () => {
    await updateTaskStatus({
      task,
      status: TaskStatus.COMPLETED,
      mutate,
    });
    stampPaperModalVisibility.hide();
  };

  const config: ServiceRequestTaskCardConfig = {
    getLeftIcon: (status) => ServiceRequestTaskIconConfig[status],
    getStateConfig: (state) => {
      const stateMap = {
        [TaskParty.CLIENT]: {
          [TaskStatus.TO_DO]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel label="Agent procures stamp paper" />
            ),
          },
          [TaskStatus.COMPLETED]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel
                label="Stamp paper procured"
                status={task.status}
                timestamp={task.updatedAt}
              />
            ),
          },
        },
        [TaskParty.AGENT]: {
          [TaskStatus.TO_DO]: {
            actions: (
              <Button
                size="sm"
                onClick={stampPaperModalVisibility.show}
                variant="primary"
              >
                <Icons.Check className="size-4" />
                Mark as completed
              </Button>
            ),
            label: (
              <ServiceRequestTaskLabel label="Mark update: Procure stamp paper" />
            ),
          },
          [TaskStatus.BACKLOG]: {
            actions: (
              <Button size="sm" disabled variant="primary">
                <Icons.Check className="size-4" />
                Mark as completed
              </Button>
            ),
            label: (
              <ServiceRequestTaskLabel label="Mark update: Procure stamp paper" />
            ),
          },
          [TaskStatus.COMPLETED]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel
                label=" Stamp paper procured"
                status={task.status}
                timestamp={task.updatedAt}
              />
            ),
          },
        },
      };

      return (
        stateMap[state.role]?.[state.status] ?? {
          label: task.title,
          actions: null,
        }
      );
    },
  };

  return (
    <div>
      <ServiceRequestTaskCard
        task={task}
        state={{
          role,
          status: task.status,
        }}
        config={config}
        context={context}
        isTimelineView={isTimelineView}
        displayNumber={displayNumber}
      />
      <ConfirmationModal
        isOpen={stampPaperModalVisibility.visible}
        onClose={stampPaperModalVisibility.hide}
        onConfirm={handleMarkAsFiled}
        title="Mark as completed"
        message="Please note that this action will update the customer. To revert this change, please contact Commenda Support."
        hideCancelButton
      />
    </div>
  );
};
